import { render, staticRenderFns } from "./CreatePatientTaxDataForm.vue?vue&type=template&id=be79d778&scoped=true"
import script from "./CreatePatientTaxDataForm.vue?vue&type=script&lang=js"
export * from "./CreatePatientTaxDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be79d778",
  null
  
)

export default component.exports